<ion-list
  lines="full"
  class="ion-color-grey-100"
>
  <ion-item
    class="default body-normal-16"
    color="grey-100"
    *ngFor="let item of items"
  >
    <ion-icon
      aria-hidden="true"
      [name]="iconPrefix + item.icon"
      slot="start"
      color="orange-500"
    ></ion-icon>
    <ion-label class="ion-text-wrap">
      {{ item.label }}
    </ion-label>
  </ion-item>
</ion-list>
